import { Component } from '@angular/core';

@Component({
    standalone: true,
    selector: 'app-empty-card-list',
    templateUrl: './empty-card-list.component.html',
    styleUrls: ['./empty-card-list.component.scss'],
})
export class EmptyCardListComponent {}
